module.exports = __webpack_public_path__ + "assets/img/JavaScript.fcf9b82b.png";